import axios from 'axios';
import { ActivityTemplate, TaggedTemplateCollection } from '../../models';
import { constants } from '../../constants';

let cachedTemplates: ActivityTemplate[] | null = null;
let cachedTaggedTemplateCollections: TaggedTemplateCollection[] | null = null;
export const getActivityTemplates = async () => {
  const token = localStorage.getItem('token');
  if (!cachedTemplates) {
    const res = await axios.get<{ templates: ActivityTemplate[] }>(
      `${constants.endpoint}/activities/templates`,
      {
        headers: {
          Authorization: `bearer ${token}`,
        },
      }
    );
    cachedTemplates = res.data.templates;
  }

  return cachedTemplates;
};

export const getTaggedTemplateCollections = async () => {
  if (cachedTaggedTemplateCollections) {
    return cachedTaggedTemplateCollections;
  }

  const templates = await getActivityTemplates();
  const taggedTemplateMap = new Map<number | null, TaggedTemplateCollection>();
  templates.forEach(template => {
    const taggedTemplates = taggedTemplateMap.get(template.tag);
    if (taggedTemplates) {
      taggedTemplates.templates.push(template);
    } else {
      taggedTemplateMap.set(template.tag, {
          id: template.tag,
          name: template.tagName,
          templates: [template]
      });
    }
  })

  cachedTaggedTemplateCollections = [...taggedTemplateMap.values()];
  return cachedTaggedTemplateCollections;
}
